/* eslint-disable react/prop-types */

import React, { useContext, useEffect } from "react";
import { Link } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Arrow from "~components/svg/Arrow";
import Burger from "~components/svg/Burger";
import Logo from "~components/svg/Logo";

import cartIcon from "~assets/images/cart.svg";

const Header = () => {
  const {
    cartActive,
    setCartActive,
    subnavActive,
    logoVisible,
    menuActive,
    notificationActive,
    setMenuActive,
    setSubnavActive,
    setSubnavLink,
    setSubscriptionOverride
  } = useContext(AppContext);

  const { scrollTop, windowWidth } = useContext(DocumentContext);

  //

  useEffect(() => {
    setSubnavActive(false);
  }, [scrollTop]);

  //

  return (
    <header
      className={`header ${menuActive ? ` menu-active` : ``} ${
        notificationActive ? `notification-active` : ``
      } w-full fixed top-0 right-0 left-0 z-30 pt-5 sm:pt-8 pb-2 pointer-events-none text-orange`}
    >
      <div
        className={`header__bg w-full h-full absolute top-0 right-0 bottom-0 left-0 flex items-end pointer-events-none ${
          subnavActive ? `active` : ``
        } bg-dark-green`}
      >
        {(windowWidth < 1440 && (
          <img
            className="w-full relative z-10 block"
            style={{ marginBottom: `-2.75vw` }}
            src="/uploads/menu-squiggle-md.svg"
            alt="Largest orange squiggle"
          />
        )) || (
          <img
            className="w-full relative z-10 block"
            style={{ marginBottom: `-1.5vw` }}
            src="/uploads/menu-squiggle-lg.svg"
            alt="Largest orange squiggle"
          />
        )}
      </div>

      <nav className="grid">
        <div className="grid-end-5 md:grid-end-4 relative z-20">
          {logoVisible && (
            <Link
              to="/"
              className="animation-appear-down animation-delay-2 block pointer-events-auto"
            >
              <Logo className="header__link sm:h-12" />
            </Link>
          )}
        </div>

        <div className="touch-only-flex grid-end-7 relative flex items-center justify-end">
          <button
            type="button"
            className="h-5 pointer-events-auto"
            onClick={() => setMenuActive(true)}
          >
            <Burger className="h-5" color="orange" />
          </button>
        </div>

        <div className="grid-end-8 relative z-20 desktop-only-flex items-center justify-end">
          <div className="header__links flex items-center justify-between">
            <button
              type="button"
              className="header__link relative block pointer-events-auto f4"
              onClick={() => setSubnavActive(!subnavActive)}
            >
              <div className="relative flex items-center">
                <span>Store</span>
                <Arrow
                  className={`header__links__arrow ${
                    subnavActive ? `inverted` : ``
                  } w-4 block ml-3`}
                />
              </div>
            </button>

            <Link to="/about" className="header__link pointer-events-auto f4">
              About
            </Link>

            <p className="header__link pointer-events-auto f4">
              <a href="https://orders.wildwoodbakery.com.au/account">
                Accounts
              </a>
            </p>

            <button
              type="button"
              className="header__link pointer-events-auto"
              onClick={() => setCartActive(!cartActive)}
            >
              <img src={cartIcon} alt="Wicker bag" />
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`header__subnav w-full ${
          subnavActive ? `active` : ``
        } relative z-10 mt-3 mb-3`}
      >
        <div className="grid">
          <div className="grid-end-12 relative z-10 flex items-center justify-end">
            <Link
              to="/products"
              className={`${
                subnavActive ? `pointer-events-auto` : ``
              } header__link relative block mr-24 f4`}
              onClick={() => {
                setSubnavLink(`preorder`);
                setSubnavActive(false);
              }}
            >
              <span className="text-light-green">Saturday Pre-Order</span>
            </Link>

            <Link
              to="/products"
              className={`${
                subnavActive ? `pointer-events-auto` : ``
              } header__link relative block f4 text-light-green`}
              onClick={() => {
                setSubnavLink(`subscription`);
                setSubscriptionOverride(true);
                setSubnavActive(false);
              }}
            >
              <span className="text-light-green">Sourdough Subscription</span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
